/**
* Product Carousel Init
*/

const splide = () => {
  const mainSlider = document.querySelector('.js-main-slider');
  const navSlider = document.querySelector('.js-nav-slider');
  
  if (mainSlider && navSlider) {
    //@ts-ignore
    var mainSplide = new Splide( mainSlider, {
      arrows: false,
      pagination: false,
    } );
    
    //@ts-ignore
    var navSplide = new Splide( navSlider, {
      direction: 'ttb',
      height: '100%',
      arrows: false,
      pagination: false,
      isNavigation: true,
      fixedWidth: '100%',
      fixedHeight: 122,
      gap: 10,
      breakpoints : {
        901: {
          gap: 5,
          direction: 'ltr',
          fixedWidth: 70,
          fixedHeight: 70,
        },
      },
    } );

    mainSplide.sync( navSplide );
    mainSplide.mount();
    navSplide.mount();
  }
}

export default splide
